import { useEffect, useState } from 'react';
import { activityAchievementPercent, loadActivityIndex, type ActivityIndexReader, type ActivityIndexSummary } from './activity-index-port';
import './activity-index-panel.css';

export function ActivityIndexPanel({ siteId, year, refresh, reader }: {
  siteId: string; year: number; refresh: number; reader?: ActivityIndexReader;
}) {
  const key = `${siteId}:${year}:${refresh}`;
  const [result, setResult] = useState<{ key: string; summary: ActivityIndexSummary | null; failed: boolean } | null>(null);
  useEffect(() => {
    let active = true;
    void loadActivityIndex({ siteId, year }, reader).then(summary => {
      if (active) setResult({ key, summary, failed: false });
    }).catch(() => { if (active) setResult({ key, summary: null, failed: true }); });
    return () => { active = false; };
  }, [siteId, year, refresh, reader, key]);
  const current = result?.key === key ? result : null;
  const summary = current?.summary;
  const ready = summary?.state === 'ready';
  const hasPlan=ready||summary?.state==='incomplete';
  const percent = summary ? activityAchievementPercent(summary) : null;
  const status = !reader ? '연결 예정' : current?.failed ? '조회 실패'
    : !current ? '조회 중' : summary?.state === 'unconfigured' ? '미설정' : '연결 예정';
  return <section className="home-panel activity-index-panel" aria-label="안전활동지수">
    <header><h2>안전활동지수</h2><small>{year}년</small></header>
    <div className="activity-index-values">
      <div><span>연간 계획목표</span><strong>{hasPlan ? summary.annualTarget.toLocaleString() : status}</strong>{hasPlan && <small>건</small>}</div>
      <div><span>현재 달성 수준</span><strong>{summary?.state==='incomplete'?'—':ready ? percent === null ? '—' : `${percent.toFixed(1)}%` : status}</strong>
        {ready && <small>{summary.completed.toLocaleString()}건</small>}</div>
    </div>
  </section>;
}
